import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const navigate = useNavigate();
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Fashion Influencer",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah",
      content: "NOONX transformed my creator journey. I've earned over ₹40 lakhs in just 6 months! The platform is intuitive and the support team is always there when I need help.",
      stat: "300% ROI",
      statIcon: "TrendingUp",
      rating: 5,
      location: "Mumbai, India",
      followers: "250K"
    },
    {
      name: "Michael Chen",
      role: "Tech Reviewer",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Michael",
      content: "The performance-based model is game-changing. Finally getting paid what I'm worth! No more negotiating rates - just pure performance-driven income.",
      stat: "₹40L Earned",
      statIcon: "DollarSign",
      rating: 5,
      location: "Bangalore, India",
      followers: "180K"
    },
    {
      name: "Emma Williams",
      role: "Lifestyle Creator",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Emma",
      content: "Best platform for serious creators. The support team is amazing and payouts are always on time. I can focus on creating content while NOONX handles everything else.",
      stat: "50+ Campaigns",
      statIcon: "Target",
      rating: 5,
      location: "New York, NY",
      followers: "320K"
    },
    {
      name: "David Rodriguez",
      role: "Fitness Influencer",
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=David",
      content: "Within 3 months, I've doubled my income. The real-time analytics help me optimize my content and the brand matches are always perfect for my audience.",
      stat: "2x Income",
      statIcon: "Zap",
      rating: 5,
      location: "Miami, FL",
      followers: "420K"
    }
  ];

  return (
    <section className="py-32 sm:py-40 lg:py-48 bg-gradient-to-b from-gray-900 via-black to-gray-900 relative overflow-hidden">
      {/* Enhanced Background Effects */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(228,35,19,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(228,35,19,0.03)_1px,transparent_1px)] bg-[size:64px_64px]"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-600/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-20 h-20 border-4 border-primary/20 rounded-full animate-float"></div>
      <div className="absolute bottom-40 left-20 w-24 h-24 bg-gradient-to-br from-primary/10 to-red-600/10 rounded-2xl rotate-45 animate-float-delayed"></div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10 max-w-7xl">
        {/* Enhanced Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-3 px-7 py-3.5 bg-gradient-to-r from-primary/20 to-red-600/20 backdrop-blur-sm rounded-full mb-10 border-2 border-primary/30 shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer animate-fade-in">
            <Icon name="Heart" size={28} className="text-primary animate-pulse" />
            <span className="text-white font-black text-base uppercase tracking-wide">Success Stories</span>
          </div>
          <h2 className="text-5xl sm:text-6xl lg:text-8xl font-black text-white mb-10 tracking-tight leading-[1.1] animate-fade-in" style={{ animationDelay: '0.1s' }}>
            Loved by{' '}
            <span className="relative inline-block">
              <span className="bg-gradient-to-r from-primary via-red-500 to-orange-500 bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">
                500+
              </span>
              <div className="absolute -bottom-4 left-0 right-0 h-3 bg-gradient-to-r from-primary/30 via-red-500/30 to-orange-500/30 rounded-full blur-sm"></div>
            </span>
            {' '}Creators
          </h2>
          <p className="text-xl sm:text-2xl text-white/80 max-w-3xl mx-auto leading-relaxed font-semibold animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Join thousands of successful creators who are <span className="text-primary font-black">earning more</span> with NOONX
          </p>
        </div>

        {/* Enhanced Testimonials Grid with Interactive Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="relative group cursor-pointer animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
              onMouseEnter={() => setActiveTestimonial(index)}
            >
              {/* Glow Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br from-primary to-red-600 rounded-3xl blur-2xl opacity-0 group-hover:opacity-40 transition-all duration-500 ${activeTestimonial === index ? 'opacity-30' : ''}`}></div>
              
              {/* Card */}
              <div className={`relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-3xl p-8 border-2 transition-all duration-500 group-hover:scale-105 group-hover:border-primary/60 h-full flex flex-col ${
                activeTestimonial === index ? 'border-primary/50 scale-105' : 'border-white/10'
              }`}>
                
                {/* Profile Section */}
                <div className="flex items-start gap-4 mb-6">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-primary to-red-600 rounded-full blur-md opacity-50 group-hover:opacity-75 transition-opacity"></div>
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="relative w-16 h-16 rounded-full border-3 border-primary shadow-xl"
                    />
                    <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-2 border-black flex items-center justify-center">
                      <Icon name="CheckCircle" size={14} className="text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-white font-black text-lg mb-1">{testimonial.name}</h3>
                    <p className="text-white/60 text-sm font-semibold mb-1">{testimonial.role}</p>
                    <div className="flex items-center gap-2 text-xs text-white/40">
                      <Icon name="MapPin" size={12} />
                      <span>{testimonial.location}</span>
                    </div>
                  </div>
                </div>

                {/* Rating Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Icon 
                      key={i} 
                      name="Star" 
                      size={18} 
                      className="text-yellow-400 fill-current"
                      style={{ animationDelay: `${i * 50}ms` }}
                    />
                  ))}
                </div>

                {/* Content */}
                <p className="text-white/90 text-base mb-6 leading-relaxed flex-1 font-medium">
                  "{testimonial.content}"
                </p>

                {/* Stats Badge */}
                <div className="space-y-3">
                  <div className="flex items-center justify-between gap-2 px-4 py-3 bg-gradient-to-r from-primary/20 to-red-600/20 rounded-xl border border-primary/30 group-hover:border-primary/50 transition-colors">
                    <Icon name={testimonial.statIcon as any} size={22} className="text-primary" />
                    <span className="text-white font-black text-base">{testimonial.stat}</span>
                  </div>
                  <div className="flex items-center justify-between px-4 py-2 bg-white/5 rounded-lg">
                    <span className="text-white/60 text-xs font-semibold">Followers</span>
                    <span className="text-white font-bold text-sm">{testimonial.followers}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Enhanced CTA Section with Social Proof */}
        <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <div className="bg-gradient-to-r from-primary via-red-600 to-orange-500 rounded-3xl p-12 sm:p-16 shadow-2xl overflow-hidden group hover:shadow-primary/50 transition-all duration-500">
            {/* Animated Background */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1),transparent_70%)] animate-pulse"></div>
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl animate-float"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-black/10 rounded-full blur-3xl animate-float-delayed"></div>
            
            <div className="relative text-center">
              <div className="mb-8 flex justify-center">
                <div className="relative">
                  <div className="flex -space-x-4">
                    {[...Array(5)].map((_, i) => (
                      <div 
                        key={i} 
                        className="w-16 h-16 rounded-full border-4 border-white shadow-xl bg-gradient-to-br from-gray-200 to-gray-400 hover:scale-110 transition-transform duration-300 cursor-pointer"
                        style={{ 
                          backgroundImage: `url(https://api.dicebear.com/7.x/avataaars/svg?seed=User${i})`,
                          backgroundSize: 'cover'
                        }}
                      ></div>
                    ))}
                  </div>
                  <div className="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg animate-bounce">
                    10K+
                  </div>
                </div>
              </div>
              
              <h3 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 tracking-tight">
                Start Your Success Story Today 🚀
              </h3>
              <p className="text-white/90 text-xl sm:text-2xl mb-10 max-w-2xl mx-auto font-semibold leading-relaxed">
                Join the <span className="font-black underline decoration-wavy">fastest-growing</span> creator community and turn your influence into income
              </p>
              
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
                <button
                  onClick={() => navigate('/authentication')}
                  className="group/btn relative bg-white text-primary font-black px-16 py-6 rounded-2xl hover:bg-black hover:text-white transition-all duration-300 hover:scale-110 text-xl shadow-2xl overflow-hidden"
                >
                  <span className="relative z-10 flex items-center gap-3">
                    Get Started Free
                    <Icon name="ArrowRight" size={28} className="group-hover/btn:translate-x-2 transition-transform duration-300" />
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-black to-gray-900 translate-x-[-100%] group-hover/btn:translate-x-0 transition-transform duration-300"></div>
                </button>
                
                <button
                  onClick={() => navigate('/authentication')}
                  className="group/btn flex items-center gap-3 text-white hover:text-black transition-all duration-300 font-bold text-lg hover:scale-105"
                >
                  <div className="p-4 bg-white/20 backdrop-blur-sm rounded-full group-hover/btn:bg-white transition-all duration-300 shadow-xl">
                    <Icon name="Play" size={24} className="ml-0.5" />
                  </div>
                  <span>Watch Success Stories</span>
                </button>
              </div>
              
              {/* Trust Indicators */}
              <div className="flex flex-wrap items-center justify-center gap-8 pt-8 border-t-2 border-white/20">
                <div className="flex items-center gap-2 text-white">
                  <div className="p-2 bg-white/20 rounded-lg">
                    <Icon name="Zap" size={20} />
                  </div>
                  <span className="text-sm font-bold">Setup in 2 mins</span>
                </div>
                <div className="flex items-center gap-2 text-white">
                  <div className="p-2 bg-white/20 rounded-lg">
                    <Icon name="CreditCard" size={20} />
                  </div>
                  <span className="text-sm font-bold">No credit card needed</span>
                </div>
                <div className="flex items-center gap-2 text-white">
                  <div className="p-2 bg-white/20 rounded-lg">
                    <Icon name="Shield" size={20} />
                  </div>
                  <span className="text-sm font-bold">100% Secure</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
